import gql from "graphql-tag";

export const deleteUserMutation = gql`
  mutation deleteUser($profileId: Int) {
    deleteUser(profileId: $profileId) {
      status
      errorMessage
    }
  }
`;

export const getAllUsers = gql`
  query getAllUsers($currentPage: Int, $userType: Int) {
    getAllUsers(currentPage: $currentPage, userType: $userType) {
      count
      results {
        email
        phoneNumber
        userStatus
        isBan
        createdAt
        profile {
          profileId
          firstName
          lastName
          country
        }
      }
    }
  }
`;

export const updateUserMutation = gql`
  mutation updateUser(
    $id: ID
    $firstName: String
    $lastName: String
    $email: String
    $phoneDialCode: String
    $phoneNumber: String
    $userStatus: String
    $isBan: Int
    $phoneCountryCode: String
    $preferredCurrency: String
  ) {
    updateUser(
      id: $id
      firstName: $firstName
      lastName: $lastName
      email: $email
      phoneDialCode: $phoneDialCode
      phoneNumber: $phoneNumber
      userStatus: $userStatus
      isBan: $isBan
      phoneCountryCode: $phoneCountryCode
      preferredCurrency: $preferredCurrency
    ) {
      status
      errorMessage
    }
  }
`;
